// import React from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import picture1 from "../img/aaaservices/amjon.png";
// import picture2 from "../img/aaaservices/Optum-logo.png";
// import picture3 from "../img/aaaservices/Carlsberg-logo.png";
// import picture4 from "../img/aaaservices/wns.png";
// import picture5 from "../img/aaaservices/wipro.png";
// import picture6 from "../img/aaaservices/cartflo.png";
// import picture7 from "../img/aaaservices/kynes.png";

// import picture9 from "../img/aaaservices/wilfargo.png";

// import picture11 from "../img/aaaservices/carelon.png";

// const OurCoPartners = () => {
//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 1000,  // Normal smooth sliding speed
//     slidesToShow: 5,
//     slidesToScroll: 1,  // Auto slide 3-3
//     autoplay: true,
//     autoplaySpeed: 2000,  // Set a delay for better auto-sliding
//     pauseOnHover: false,
//     arrows: false,
//     responsive: [
//       { breakpoint: 1440, settings: { slidesToShow: 5, slidesToScroll: 3 } },
//       { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 2 } },
//       { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
//     ],
//   };
  
  

//   return (
//     <div style={sectionStyle}>
//       <h1 style={headingStyle}>
//         Our <span style={{ color: "rgb(235, 195, 101)" }}>Clients</span>
//       </h1>
//       <div style={underlineStyle}></div>
//       <div style={{ width: "110%" }}>
//         <Slider {...settings}>
//           {[picture1, picture2, picture3, picture4, picture5, picture6, picture7,,picture9,picture11,].map((image, index) => (
//             <div key={index} style={cardStyle}>
//               <div style={circleContainerStyle}>
//                 <img src={image} alt={`Partner ${index + 1}`} style={imageStyle} />
//                 <div style={overlayStyle} className="overlay">
                
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </div>
//   );
// };

// const sectionStyle = {
//   textAlign: "center",
//   padding: "40px 20px",
//   marginTop:'-50px'
// };

// const headingStyle = {
//   fontSize: "48px",
//   fontFamily: "Lato, sans-serif",
//   position: "relative",
//   display: "inline-block",
// };

// const underlineStyle = {
//   width: "200px",
//   height: "2px",
//   backgroundColor: "#000",
//   margin: "10px auto",
//   marginTop:'-20px'
// };

// const cardStyle = {
//   display: "flex",
//   justifyContent: "center",
// };

// const circleContainerStyle = {
//   width: "150px",
//   height: "150px",
//   borderRadius: "50%",
//   overflow: "hidden",
//   position: "relative",
//   border: "5px solid #eae9f9",
//   boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.1)",
//   transition: "transform 0.3s ease",
//   cursor: "pointer",
// };

// const imageStyle = {
//   width: "100%",
//   height: "100%",
//   objectFit: "contain",
//   transition: "0.3s ease",
// };

// const overlayStyle = {
//   position: "absolute",
//   top: 0,
//   left: 0,
//   width: "100%",
//   height: "100%",
//   background: "rgba(0, 0, 0, 0.7)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   opacity: 0,
//   transition: "opacity 0.3s ease",
// };

// const overlayTextStyle = {
// //   color: "#fff",
// //   fontSize: "16px",
// //   fontWeight: "bold",
// };

// export default OurCoPartners;










// import React, { useState } from 'react';
// import daf from '../img/logos-to-add/daf.PNG';
// import escad from '../img/logos-to-add/escad.PNG';
// import fft from '../img/logos-to-add/fft.PNG';
// import ford from '../img/logos-to-add/ford.PNG';
// import introsy from '../img/logos-to-add/introsy.PNG';
// import it8 from '../img/logos-to-add/it8.PNG';
// import Jaguar from '../img/logos-to-add/Jaguar-company.PNG';
// import lt from '../img/tierone-images/l&t.909266653aee54006e3d.png';
// import mldk from '../img/logos-to-add/mldk.PNG';
// import tata from '../img/logos-to-add/tata.PNG';
// import tyseekar from '../img/tierone-images/tyseekar.c7f2621b65de76ae2566.png';
// import vdl from '../img/logos-to-add/vdl.PNG';
// import TataTechTier2 from '../img/aaaservices/tata.png';
// import EbzTire1 from '../img/tierone-images/EbzTire1.png';
// import SkodaRakdom from '../img/tierone-images/skooda.png';
// import ComauRakdom from '../img/tierone-images/ComauRakdom.png';
// import VolvoRakdom from '../img/tierone-images/VolvoRakdom.png';
// import psaGroupRakdom from '../img/tierone-images/psaGroupRakdom.png';

// const FastrackYourCarrier = () => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     const containerStyle = {
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         width: '120px',
//         height: '120px',
//         border: '2px solid #d5d6dd',
//         // borderColor:'black',
//         boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.1)',
//         borderRadius: '50%',
//         margin: '10px',
//         overflow: 'hidden',
//         backgroundColor: '#fff',
//         transition: 'transform 0.3s ease',
//         marginBottom: '100px',
//     };

//     const imgStyle = {
//         width: '85%',
//         height: '200px',
//         objectFit: 'contain',
//     };

//     return (
//         <div>
//             <div className="row d-flex justify-content-center fstract" style={{ marginBottom: '100px',width:'100%' }}>
//                 <div className=" forMarginGiven col-lg-12" style={{ paddingBottom: '30px', marginBottom: '80px',marginTop:'40px' }}>

//                     <h2 style={{ textAlign: 'center', fontSize: '48px',  }} >
//                         Fastrack <span style={{ color: '#f7941d' }}>Your Career</span>
//                     </h2>

                    
//                     <p style={{ textAlign: 'center',fontSize:'22px',fontFamily:'roboto',fontWeight:'400', }} className="fastparagrap">
//                         With IIA, unlock your remarkable career transition, unprecedented career kick-starting and join top-tier companies worldwide.
//                     </p>
//                 </div>

//                 <div className=" forTheWidth col-xl-3" style={{ width: "200px" }}>
//                     <div
//                         className="row fastractlearner"
//                         style={{
//                             padding: '30px',
//                             border: '1px solid #d5d6dd',
//                             height: '790px',
//                             boxShadow: '0px 7px 7px rgb(216, 220, 247)',
//                             fontFamily: 'lato sans,serif',
//                         }}
//                     >
//                         <h3
//                             style={{
//                                 textAlign: 'center',
//                                 // marginLeft: '-36px',
//                                 fontWeight: 'bold',
//                                 color: '#333',
//                                 fontFamily:'roboto',
//                                fontSize:'28px',
//                                marginTop:'-80px',
//                             }}
//                             className="fastrack-head"
//                         >
//                             Learner's Achievements
//                         </h3>

//                         <div className="col-lg-12 achievement-box">
//                             <p style={{ fontSize: '30px', margin: '0', fontFamily: 'lato sans,serif', }}>Average Salary</p>
//                             <p
//                                 style={{
//                                     fontSize: '50px',
//                                     color: 'blue',
//                                     fontWeight: '800',
//                                     fontFamily: 'lato sans,serif',
//                                 }}
//                             >
//                                 70%
//                             </p>
//                         </div>

//                         <div className="col-lg-12 achievement-box">
//                             <p style={{ fontSize: '30px', margin: '0', fontFamily: 'lato sans,serif', }}>Maximum Salary Hike</p>
//                             <p
//                                 style={{
//                                     fontSize: '50px',
//                                     color: 'blue',
//                                     fontWeight: '800',
//                                     fontFamily: 'lato sans,serif',
//                                 }}
//                             >
//                                 150%
//                             </p>
//                         </div>

//                         <div className="col-lg-12 achievement-box">
//                             <p style={{ fontSize: '30px', margin: '0', fontFamily: 'lato sans,serif', }}>Hiring Partners</p>
//                             <p
//                                 style={{
//                                     fontSize: '50px',
//                                     color: 'blue',
//                                     fontWeight: '800',
//                                     fontFamily: 'lato sans,serif',
//                                 }}
//                             >
//                                 2900+
//                             </p>
//                         </div>
//                     </div>

//                     {/* Internal CSS */}
//                     <style>
//                         {`
//                             .achievement-box {
//                                 display: flex;
//                                 flex-direction: column;
//                                 justify-content: center;
//                                 align-items: center;
//                                 border: 1px solid #d5d6dd;
//                                 box-shadow: 7px 7px 15px rgba(0, 0, 0, 0.1);
//                                 border-radius: 10px;
//                                 padding: 40px;
//                                 margin: 10px 0;
//                                 min-height: 50px; 
//                                 background-color: #fff;
//                                 transition: transform 0.3s ease, box-shadow 0.3s ease;
//                             }

//                             .achievement-box:hover {
//                                 transform: scale(1.05);
//                                 box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.2);
//                             }

//                             /* Media Query for Mobile Devices */
//                             @media (max-width: 768px) {
//                                 .fastractlearner {
//                                     padding: 15px;
//                                 }

//                                 .achievement-box {
//                                     padding: 20px;
//                                     min-height: 150px;
//                                     margin: 10px 0;
//                                 }

//                                 .achievement-box p {
//                                     font-size: 24px;
//                                 }

//                                 .achievement-box p:last-child {
//                                     font-size: 36px;
//                                 }

//                                 h3.fastrack-head {
//                                     font-size: 24px;
//                                     margin-left: 0;
//                                     text-align: center;
//                                 }
//                             }

//                             /* Media Query for Very Small Screens */
//                             @media (max-width: 480px) {
//                                 .achievement-box {
//                                     padding: 15px;
//                                     min-height: 130px;
//                                 }

//                                 .achievement-box p {
//                                     font-size: 20px;
//                                 }

//                                 .achievement-box p:last-child {
//                                     font-size: 28px;
//                                 }

//                                 h3.fastrack-head {
//                                     font-size: 20px;
//                                     text-align: center;
//                                 }
//                             }
//                         `}
//                     </style>
                   

//                 </div>
//                 <div className="col-xl-7" style={{ border: '1px solid #d5d6dd', boxShadow: '7px 7px 7px rgb(216, 220, 247)' }}>
//                     <div className="row">
//                         <div className="col-12">
//                             <h3 style={{ textAlign: 'center',fontSize:'25px',fontFamily:'roboto', }} className="fastrack-alumini">Top Industry Employers</h3>
//                         </div>
//                         <div className="row" style={{ fontFamily: 'lato sans,serif', }}>
//                             {[
//                                 { title: 'OEM’S', logos: [ford, tata, daf, Jaguar, SkodaRakdom, VolvoRakdom] },
//                                 { title: 'TIER-1', logos: [fft, vdl, tyseekar, escad, EbzTire1, psaGroupRakdom] },
//                                 { title: 'TIER-2', logos: [it8, introsy, lt, mldk, TataTechTier2, ComauRakdom] },
//                             ].map((row, rowIndex) => (
//                                 <div key={rowIndex} className="col-lg-4" style={{ marginBottom: '20px' }}>
//                                     <h4 style={{ textAlign: 'center', marginBottom: '15px' }}>{row.title}</h4>
//                                     <div className="d-flex flex-wrap justify-content-center">
//                                         {row.logos.map((logo, logoIndex) => (
//                                             <div
//                                                 className='styleContainerer'
//                                                 key={logoIndex}
//                                                 style={{
//                                                     ...containerStyle,
//                                                     transform: hoveredIndex === `${rowIndex}-${logoIndex}` ? 'scale(1.1)' : 'scale(1)',
//                                                 }}
//                                                 onMouseEnter={() => setHoveredIndex(`${rowIndex}-${logoIndex}`)}
//                                                 onMouseLeave={() => setHoveredIndex(null)}
//                                             >
//                                                 <img src={logo} alt="Company logo" style={imgStyle} />
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default FastrackYourCarrier;




// import React, { useState } from 'react';
// import daf from '../img/logos-to-add/daf.PNG';
// import escad from '../img/logos-to-add/escad.PNG';
// import fft from '../img/logos-to-add/fft.PNG';
// import ford from '../img/logos-to-add/ford.PNG';
// import introsy from '../img/logos-to-add/introsy.PNG';
// import it8 from '../img/logos-to-add/it8.PNG';
// import Jaguar from '../img/logos-to-add/Jaguar-company.PNG';
// import lt from '../img/tierone-images/l&t.909266653aee54006e3d.png';
// import mldk from '../img/logos-to-add/mldk.PNG';
// import tata from '../img/logos-to-add/tata.PNG';
// import tyseekar from '../img/tierone-images/tyseekar.c7f2621b65de76ae2566.png';
// import vdl from '../img/logos-to-add/vdl.PNG';
// import TataTechTier2 from '../img/aaaservices/tata.png';
// import EbzTire1 from '../img/tierone-images/EbzTire1.png';
// import SkodaRakdom from '../img/tierone-images/skooda.png';
// import ComauRakdom from '../img/tierone-images/ComauRakdom.png';
// import VolvoRakdom from '../img/tierone-images/VolvoRakdom.png';
// import psaGroupRakdom from '../img/tierone-images/psaGroupRakdom.png';
// import It from '../img/aaaservices/micro.png';
// import It1 from '../img/aaaservices/Wipro_Primary_Logo_Color_RGB.svg.png';
// import It2 from '../img/aaaservices/HCL-Foundation.png';
// import It3 from '../img/aaaservices/Tech_Mahindra-Logo.wine.png';
// import It4 from '../img/aaaservices/download.png';
// import It5 from '../img/aaaservices/info.png';



// const FastrackYourCarrier = () => {
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   const containerStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     width: '120px',
//     height: '120px',
//     border: '2px solid #d5d6dd',
//     boxShadow: '4px 4px 10px rgba(0, 0, 0, 0.1)',
//     borderRadius: '50%',
//     margin: '10px',
//     overflow: 'hidden',
//     backgroundColor: '#fff',
//     transition: 'transform 0.3s ease',
//   };

//   const imgStyle = {
//     width: '85%',
//     height: '200px',
//     objectFit: 'contain',
//   };

//   const logoSection = (title, logos, rowIndex) => (
//     <div className="col-12 mb-4">
//       <h4 style={{ textAlign: 'center', fontWeight: 'bold', fontFamily: 'Roboto' }}>{title}</h4>
//       <div className="d-flex flex-wrap justify-content-center">
//         {logos.map((logo, logoIndex) => (
//           <div
//             key={logoIndex}
//             style={{
//               ...containerStyle,
//               transform: hoveredIndex === `${rowIndex}-${logoIndex}` ? 'scale(1.1)' : 'scale(1)',
//             }}
//             onMouseEnter={() => setHoveredIndex(`${rowIndex}-${logoIndex}`)}
//             onMouseLeave={() => setHoveredIndex(null)}
//           >
//             <img src={logo} alt="Company logo" style={imgStyle} />
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div className="container-fluid">
//       <div className="row justify-content-center" style={{ marginTop: '40px' }}>
//         <div className="col-12 text-center mb-4">
//           <h2 style={{ fontSize: '48px' }}>
//             Fastrack <span style={{ color: '#f7941d' }}>Your Career</span>
//           </h2>
//           {/* <p style={{ fontSize: '22px', fontFamily: 'Roboto', fontWeight: 400 }}>
//             With IIA, unlock your remarkable career transition, unprecedented career kick-starting and join top-tier companies worldwide.
//           </p> */}
//         </div>

//         <div className="col-12 text-center mb-3">
//           <h3 style={{ fontSize: '25px', fontFamily: 'Roboto' }}>Top Industry Employers</h3>
//         </div>

//         {/* OEM Companies Row */}
//         {logoSection('', [ford, tata, daf, Jaguar, SkodaRakdom, VolvoRakdom], 0)}

//         {/* Tier 1 Companies Row */}
//         {logoSection('', [fft, vdl, tyseekar, escad, EbzTire1, psaGroupRakdom], 1)}

//         {/* Tier 2 Companies Row */}
//         {logoSection('', [it8, introsy, lt, mldk, TataTechTier2, ComauRakdom], 2)}
//         {logoSection('', [It, It1 , It2, It3, It4, It5], 2)}

//         {/* Achievements Row */}
//         <div className="col-12 mt-4">
//           <div className="row justify-content-center">
//             {[
//               { label: 'Average Salary Hike', value: '70%' },
//               { label: 'Maximum Salary Hike', value: '150%' },
//               { label: 'Hiring Partners', value: '2900+' },
//             ].map((item, idx) => (
//               <div className="col-md-3 col-sm-6 mb-3" key={idx}>
//                 <div className="achievement-box text-center">
//                   <p style={{ fontSize: '24px', margin: '0', fontFamily: 'lato sans,serif' }}>{item.label}</p>
//                   <p style={{ fontSize: '40px', fontWeight: '800', color: 'blue' }}>{item.value}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Internal Styles */}
//       <style>{`
//         .achievement-box {
//           border: 1px solid #d5d6dd;
//           border-radius: 10px;
//           padding: 30px;
//           background-color: #fff;
//           box-shadow: 7px 7px 15px rgba(0, 0, 0, 0.1);
//           transition: transform 0.3s ease, box-shadow 0.3s ease;
//         }

//         .achievement-box:hover {
//           transform: scale(1.05);
//           box-shadow: 10px 10px 20px rgba(0, 0, 0, 0.2);
//         }

//         @media (max-width: 768px) {
//           .achievement-box p {
//             font-size: 18px !important;
//           }

//           .achievement-box p:last-child {
//             font-size: 30px !important;
//           }
//         }

//         @media (max-width: 480px) {
//           .achievement-box {
//             padding: 20px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default FastrackYourCarrier;






import React from 'react'; 
import picture1 from "../img/aaaservices/amjon.png";
import picture2 from "../img/aaaservices/Optum-logo.png";
import picture3 from "../img/aaaservices/Carlsberg-logo.png";
import picture4 from "../img/aaaservices/wns.png";
import picture5 from "../img/aaaservices/wipro.png";
import picture6 from "../img/aaaservices/cartflo.png";
import picture7 from "../img/aaaservices/kynes.png";
import picture8 from "./72f372aa-0ed6-4c45-b2e3-eb5f6d8f78a5_removalai_preview.png";
import picture9 from "../img/aaaservices/acenetutre.png";
import picture10 from "../img/aaaservices/ASG-Logo.webp";
import picture11 from "../img/aaaservices/carelon.png";
import picture12 from "../img/aaaservices/Dell_logo.png";
import picture13 from "../img/aaaservices/Logo-pwc.png";
import picture14 from "../img/aaaservices/logUse6.png";
import picture15 from "../img/aaaservices/oldman.png";
import picture16 from "../img/aaaservices/ronelogo.png";
import picture17 from "../img/aaaservices/sp.png";
import picture18 from "../img/aaaservices/tcs.png";
import picture19 from "../img/aaaservices/UBS-Logo.wine.png";




const logos1 = [picture1, picture2, picture3, picture4, picture5, picture6, picture7];
const logos2 = [picture8, picture9, picture10, picture11, picture12, picture13, picture14];
const logos3 = [picture15, picture16, picture17, picture18, picture19,];

const TrustedCompaniesSlider = () => {
  const renderSlider = (logos, direction, index) => (
    <div
      key={index}
      style={{
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        marginBottom: '30px'
      }}
    >
      <div
        className={`scroll-${direction}`}
        style={{
          display: 'flex',
          width: 'calc(200% + 20px)',
          animation: `scroll-${direction} 30s linear infinite`
        }}
      >
        {[...logos, ...logos].map((logo, idx) => (
          <div
            key={idx}
            style={{
              flex: '0 0 auto',
              width: '180px',
              margin: '0 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={logo}
              alt={`logo-${index}-${idx}`}
              style={{
                width: '100%',
                maxHeight: '61px',
                objectFit: 'contain'
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );


  const sectionStyle = {
  textAlign: "center",
  padding: "40px 20px",
  marginTop:'-50px'
};

const headingStyle = {
  fontSize: "48px",
  fontFamily: "Lato, sans-serif",
  position: "relative",
  display: "inline-block",
};

const underlineStyle = {
  width: "200px",
  height: "2px",
  backgroundColor: "#000",
  margin: "10px auto",
  marginTop:'-20px'
};

const cardStyle = {
  display: "flex",
  justifyContent: "center",
};

const circleContainerStyle = {
  width: "150px",
  height: "150px",
  borderRadius: "50%",
  overflow: "hidden",
  position: "relative",
  border: "5px solid #eae9f9",
  boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.1)",
  transition: "transform 0.3s ease",
  cursor: "pointer",
};

const imageStyle = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  transition: "0.3s ease",
};

const overlayStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  opacity: 0,
  transition: "opacity 0.3s ease",
};

const overlayTextStyle = {
//   color: "#fff",
//   fontSize: "16px",
//   fontWeight: "bold",
};

  return (
    <div style={{ background: '#f2f2f2', padding: '-1px 20px' }}>
      <div style={{ maxWidth: '1483px', margin: '0 auto', textAlign: 'center' }}>
        <h1 style={headingStyle}>
         Our <span style={{ color: "rgb(235, 195, 101)" }}>Clients</span>
       </h1>
       <div style={underlineStyle}></div>


        {renderSlider(logos1, 'left', 1)}
        {renderSlider(logos2, 'right', 2)}
        {renderSlider(logos3, 'left', 3)}
      </div>

      <style>
        {`
          @keyframes scroll-left {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          @keyframes scroll-right {
            0% { transform: translateX(-50%); }
            100% { transform: translateX(0); }
          }

          @media (max-width: 768px) {
            h2 {
              font-size: 32px !important;
            }
            div[style*="width: 180px"] {
              width: 100px !important;
              margin: 0 10px !important;
            }
          }

          @media (max-width: 480px) {
            h2 {
              font-size: 26px !important;
            }
            div[style*="width: 180px"] {
              width: 80px !important;
              margin: 0 8px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default TrustedCompaniesSlider;

